export const LINKEDIN_PLACEHOLDER_URL = 'https://www.linkedin.com/in/your-linkedin-profile/';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/';
